import Api from './Api';

class LogicBaseSearchApi extends Api {
  url = 'logicbasesearch';
}

const singleton = new LogicBaseSearchApi();
export default singleton;
